import React, { useState } from 'react'
import { TextInput, Button, useNotifications } from '@wallyhealth/web-core'
import trim from 'validator/lib/trim'
import classes from 'classnames'
import styles from './index.module.css'
import { isValidPhoneNumber } from 'validators/phoneValidator'
import { isValidEmail } from 'validators/emailValidator'
import intelService from 'services/intelService'
import adsFacade from 'facades/adsFacade'

const CustomerForm = ({ className, buttonClassName, onSubmit, buttonLabel, viewName }) => {
  const notifications = useNotifications()

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')

  const sanitize = (value) => {
    return trim(value)
  }

  const isButtonEnabled = () => {
    return sanitize(firstName) && sanitize(lastName) && sanitize(email) && sanitize(phone)
  }

  const recordSubmitClick = async (sanitizedInputs) => {
    const { eventId } = await intelService.recordClick({
      clickName: 'CustomerFormSubmit',
      viewName,
      identity: sanitizedInputs
    })
    adsFacade.recordAddToCartEvent({
      eventId,
      identity: sanitizedInputs
    })
  }

  const handleSubmit = () => {
    const sanitizedInputs = {
      firstName: sanitize(firstName),
      lastName: sanitize(lastName),
      email: sanitize(email),
      phone: sanitize(phone)
    }

    if (!isValidEmail(sanitizedInputs.email)) {
      notifications.error('Please enter a valid email.')
      return
    }

    if (!isValidPhoneNumber(sanitizedInputs.phone)) {
      notifications.error('Please enter a valid US phone number.')
      return
    }

    recordSubmitClick(sanitizedInputs)

    onSubmit(sanitizedInputs)
  }

  return (
    <div className={classes(styles.container, className)}>
      <div className={styles.form}>
        <div className={styles.names}>
          <TextInput
            className={styles.name}
            label="First Name"
            value={firstName}
            onValueChange={setFirstName}
          />

          <TextInput
            className={styles.name}
            label="Last Name"
            value={lastName}
            onValueChange={setLastName}
          />
        </div>

        <TextInput
          className={styles.email}
          label="Email"
          value={email}
          onValueChange={setEmail}
        />

        <TextInput
          label="Phone"
          className={styles.phone}
          onValueChange={setPhone}
          value={phone}
        />
      </div>
      <Button
        className={classes(styles.button, buttonClassName)}
        onClick={handleSubmit}
        disabled={!isButtonEnabled()}
        label={buttonLabel}
      />
    </div>
  )
}

export default CustomerForm
